import { __assign } from "tslib";
import React from 'react';
import { StyledButton, Children, Spinner } from './styled';
export var Button = React.forwardRef(function (props, ref) {
    return (React.createElement(StyledButton, __assign({}, props, { ref: ref }),
        React.createElement(Children, null, props.children),
        props.loading && (React.createElement(Spinner, { size: props.size === 'small' ? 16 : props.size === 'medium' ? 20 : 24, color: 'inherit' }))));
});
Button.displayName = "Button";
//# sourceMappingURL=button.js.map